export default {
  path: '/approveManage',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'approveManage',
  component: () => import('./index')
};
